export default __webpack_public_path__ + "static/media/tom_xia.3aa83ef9.png";